import profileUpdatePasswordRedux from '../../components/updatePassword/redux/reducer';

//export redux objects
export default {
	profileUpdatePasswordRedux
};
